import { MetagraphIndexerBaseUrl } from '@/common/consts/api.ts';
import { Snapshot } from '@/common/types/snapshot.ts';
import { createResourcesProvider } from '@/common/utils/resources_provider.tsx';

const [SnapshotsProvider, useSnapshotsProvider] = createResourcesProvider(
  'SnapshotsProvider',
  {
    snapshots: {
      apiUrl: `${MetagraphIndexerBaseUrl}/snapshots`,
      initialState: [] as Snapshot[],
      queryParams: {},
      resource: {} as Snapshot[],
      pathParams: {},
      pagination: { size: 10 }
    },
    snapshot: {
      apiUrl: `${MetagraphIndexerBaseUrl}/snapshots/:ordinal`,
      initialState: null,
      queryParams: {},
      resource: {} as Snapshot,
      pathParams: {} as { ordinal: number }
    }
  }
);

export { SnapshotsProvider, useSnapshotsProvider };
